import { gql } from "@stadium/services/apollo-client";
import { ADDRESS_DETAILS } from "@stadium/checkout/src/graphql/fragments/address/details";

export const fetchAddressList = gql`
  query fetchAddressList @api(name: "users") {
    addresses {
      ...AddressDetails
    }
  }
  ${ADDRESS_DETAILS}
`;
